const initialState = {
  oscuro: null,
  claro: null,
};

export default function theme(state = initialState, action: any) {
  switch (action.type) {
    case "SET_THEME":
      const { theme, modo } = action.payload;

      return {
        ...state,
        ...theme,
        ...theme[modo],
        //@ts-ignore
        colorBullet: theme[modo]?.colorBullet || "",
        //@ts-ignore
        loaderSpinner: theme[modo]?.loaderSpinner || null,
        //@ts-ignore
        dashboardTheme: theme[modo]?.dashboardTheme || null,
        //@ts-ignore
        reporteColor: theme[modo]?.reporteColor || null,
        //@ts-ignore
        titleReporte: theme[modo]?.titleReporte || null,
        //@ts-ignore
        themeTabs: theme[modo]?.themeTabs || null,
        //@ts-ignore
        themeMenu: theme[modo]?.themeMenu || null,
        iconsProfile: theme[modo]?.iconsProfile || null,
        filterThema: theme[modo]?.filterThema || null,
        inputTheme: theme[modo]?.inputTheme || null,
      };
    case "SET_THEME_MODO":
      //@ts-ignore
      const selectTheme: object | null = state[action.modo];
      return {
        ...state,
        ...selectTheme,
        //@ts-ignore
        colorBullet: selectTheme?.colorBullet || "",
        //@ts-ignore
        loaderSpinner: selectTheme?.loaderSpinner || null,
        //@ts-ignore
        dashboardTheme: selectTheme?.dashboardTheme || null,
        //@ts-ignore
        reporteColor: selectTheme?.reporteColor || null,
        //@ts-ignore
        titleReporte: selectTheme?.titleReporte || null,
        //@ts-ignore
        themeTabs: selectTheme?.themeTabs || null,
        //@ts-ignore
        themeMenu: selectTheme?.themeMenu || null,
        //@ts-ignore
        iconsProfile: selectTheme?.iconsProfile || null,
        //@ts-ignore
        filterThema: selectTheme?.filterThema || null,
        //@ts-ignore
        inputTheme: selectTheme?.inputTheme || null,
      };
    default:
      return state;
  }
}
